import { Identifiable } from './repository-params';
import { Settlement } from './settlement.interface';
import { marker as _ } from '@bling-fe/shared/utils';
import { UserShort } from './user.interface';
import { TimeSlot } from './time-slot.interface';
import { flinkIcons } from '@bling-fe/shared/icons/icons/flink';

/**
 * HourlyReservableEntity in BE
 *
 */
export interface HourlyReservable extends Identifiable {
  name: string;
  description: string;
  main_settlement: Settlement;
  entity_type: HourlyReservableType;
  photos: { picture_url: string }[];
  address: string;
  room_size: string;
  reservation_info: string;
  external_booking: boolean;
  responsible_users: Array<UserShort>;
  homepage_url: string;
  time_slots: Array<TimeSlot>;
  max_usage: number;
  terms_and_conditions_enabled: boolean;
  specific_terms_and_conditions_key?: string;
  terms_and_conditions_body?: string;
  terms_and_conditions_file_url?: string;
  allow_comments: boolean;
  reservation_days_in_advance: number;
  payments_enabled: boolean;
  offline_payment_allowed: boolean;
  price: number;
  non_refundable_hours_before: number;
  payment_conditions: string;
  cancellation_policy: string;
  key_box_enabled: boolean;
  show_reservations_overview: boolean;
}

export interface HourlyReservableQueryParams {
  entity_type: HourlyReservableType;
}

export type HourlyReservableType =
  | 'generic'
  | 'bicycle'
  | 'grill'
  | 'community_room'
  | 'repair_shop'
  | 'music_room'
  | 'kitchen'
  | 'sauna'
  | 'pizza_oven'
  | 'ebike'
  | 'ecar'
  | 'workplace_coworking'
  | 'guest_room';

interface HourlyReservableInfo {
  icon: (typeof flinkIcons)[number]['name'];
  title: string;
}

export const hourlyReservableInfo = new Map<
  HourlyReservableType,
  HourlyReservableInfo
>([
  [
    'generic',
    {
      title: _('PAGES.MY_TENANT.RESERVATIONS.GENERIC'),
      icon: 'puzzle-piece'
    }
  ],
  [
    'bicycle',
    {
      title: _('PAGES.MY_TENANT.RESERVATIONS.BICYCLE'),
      icon: 'bicycle'
    }
  ],
  [
    'grill',
    {
      title: _('PAGES.MY_TENANT.RESERVATIONS.GRILL'),
      icon: 'grill'
    }
  ],
  [
    'community_room',
    {
      title: _('PAGES.MY_TENANT.RESERVATIONS.COMMUNITY_ROOM'),
      icon: 'conference'
    }
  ],
  [
    'repair_shop',
    {
      title: _('PAGES.MY_TENANT.RESERVATIONS.REPAIR_SHOP'),
      icon: 'craft'
    }
  ],
  [
    'music_room',
    {
      title: _('PAGES.MY_TENANT.RESERVATIONS.MUSIC_ROOM'),
      icon: 'music-room'
    }
  ],
  [
    'kitchen',
    {
      title: _('PAGES.MY_TENANT.RESERVATIONS.KITCHEN'),
      icon: 'fork-knife'
    }
  ],
  [
    'sauna',
    {
      title: _('PAGES.MY_TENANT.RESERVATIONS.SAUNA'),
      icon: 'sauna'
    }
  ],
  [
    'pizza_oven',
    {
      title: _('PAGES.MY_TENANT.RESERVATIONS.PIZZA_OVEN'),
      icon: 'pizza-oven'
    }
  ],
  [
    'ebike',
    {
      title: _('PAGES.MY_TENANT.RESERVATIONS.EBIKE'),
      icon: 'bicycle'
    }
  ],
  [
    'ecar',
    {
      title: _('PAGES.MY_TENANT.RESERVATIONS.ECAR'),
      icon: 'car'
    }
  ],
  [
    'workplace_coworking',
    {
      title: _('PAGES.MY_TENANT.RESERVATIONS.COWORKING_WORKPLACE'),
      icon: 'laptop'
    }
  ],
  [
    'guest_room',
    {
      title: _('PAGES.MY_TENANT.RESERVATIONS.GUEST_ROOM'),
      icon: 'bed'
    }
  ]
]);
